import script from "./WeekStatistic.vue?vue&type=script&setup=true&lang=js"
export * from "./WeekStatistic.vue?vue&type=script&setup=true&lang=js"

import "./WeekStatistic.vue?vue&type=style&index=0&id=77e9da4c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77e9da4c"]])

export default __exports__